import {
  Button,
  ButtonGroup,
  Flex,
  Input,
  InputGroup,
  InputLeftElement,
  InputRightElement,
  Link,
} from "@chakra-ui/react";
import { SyntheticEvent, useCallback, useMemo, useState } from "react";
import { GoX } from "react-icons/go";
import { HiOutlineSearch } from "react-icons/hi";
import { Link as RouterLink, useLocation, useNavigate } from "react-router-dom";

import { useFlags } from "src/common/useFlags";
import { IntercomsFilterPopover } from "src/routes/ProductUnits/Intercoms/IntercomsFilterPopover";
import { IntercomUploadButton } from "src/routes/ProductUnits/Intercoms/IntercomUploadButton";

export const IntercomsFilterBar = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const flags = useFlags();
  const searchParams = useMemo(
    () => new URLSearchParams(location.search),
    [location.search]
  );
  const [serialNumber, setSerialNumber] = useState<string>(
    searchParams.get("serialNumber") || ""
  );

  const onSubmit = useCallback(
    (newSp: URLSearchParams) => {
      newSp.delete("pageNumber");
      searchParams.sort();
      newSp.sort();

      if (searchParams.toString() !== newSp.toString()) {
        navigate(`?${newSp.toString()}`);
      }
    },
    [searchParams]
  );

  const handleSubmit = useCallback(
    (event: SyntheticEvent) => {
      event.preventDefault();
      const newSp = new URLSearchParams(location.search);

      if (serialNumber) {
        newSp.set("serialNumber", serialNumber);
      } else {
        newSp.delete("serialNumber");
      }

      onSubmit(newSp);
    },
    [location.search, serialNumber, searchParams]
  );

  const clearSearch = () => {
    const newSp = new URLSearchParams(location.search);
    newSp.delete("serialNumber");
    setSerialNumber("");

    onSubmit(newSp);
  };

  return (
    <Flex flexDirection="row">
      <form onSubmit={handleSubmit}>
        <InputGroup width={503} marginRight="16px">
          <InputLeftElement pointerEvents="none" color="gray.300">
            <HiOutlineSearch />
          </InputLeftElement>
          <Input
            value={serialNumber}
            onChange={({ currentTarget: { value } }) => setSerialNumber(value)}
            onBlur={handleSubmit}
            placeholder="Search for serial number"
          />
          <InputRightElement>
            <Button variant="ghost" onClick={clearSearch}>
              <GoX />
            </Button>
          </InputRightElement>
        </InputGroup>
      </form>
      <ButtonGroup gap="8px">
        <IntercomsFilterPopover onSubmit={onSubmit} />
        {flags.gen4AdminPortal && <IntercomUploadButton />}
        <Link as={RouterLink} to={`add`}>
          <Button colorScheme="brand.blue">Add Intercom</Button>
        </Link>
      </ButtonGroup>
    </Flex>
  );
};
